import styled from '@emotion/styled';

export const MainBlock = styled.div`
  padding: 24px;
`;

export const Intro = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.AccentCornsilk};
  color: ${({ theme }) => theme.colors.Black24};
  font-family: 'SF Pro Text', sans-serif;
  font-size: 13px;
  line-height: 18px;
  max-width: 900px;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(300px, 1fr));
  gap: 24px;
  align-items: start;
`;

export const Column = styled.section`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.SurfaceWhite};
  border: 1px solid ${({ theme }) => theme.colors.WhiteGray20};
  overflow: hidden;
`;

export const ColumnHead = styled.header`
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.WhiteGray20};
`;

export const ColumnTitle = styled.div`
  font-family: 'SF Pro Text', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const ColumnSource = styled.div`
  margin-top: 4px;
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.Gray};
`;

export const Row = styled.div`
  padding: 12px 0;

  & + & {
    border-top: 1px dashed ${({ theme }) => theme.colors.WhiteGray20};
  }
`;

export const RowHead = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 8px;
`;

export const RowName = styled.span`
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.DarkBlue};
`;

export const RowSpec = styled.span`
  font-family: 'SF Pro Text', sans-serif;
  font-size: 11px;
  color: ${({ theme }) => theme.colors.Gray};
`;

export const Sample = styled.div`
  & + & {
    margin-top: 8px;
  }
`;

export const SampleLabel = styled.div`
  margin-bottom: 2px;
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 10px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.WhiteGray};
`;
